/**
 * URL Display Rule Matcher
 *
 * Matches URL display rules against the current page URL.
 */

import type { DisplayRule } from '@/domain/configuration';
import { DISPLAY_RULE_TYPE, RULE_TYPES } from '@/domain/configuration';

interface MatchContext {
  url: string;
}

// The matchTypes the switch below implements. Anything else throws.
export const URL_MATCH_TYPES = new Set<string>([RULE_TYPES.CONTAINS, RULE_TYPES.EXACT, RULE_TYPES.REGEX]);

export default function urlDisplayRuleMatcher(rule: DisplayRule, context: MatchContext): boolean {
  if (rule.type !== DISPLAY_RULE_TYPE.URL) {
    throw new Error(`expected rule type URL but got ${rule.type}, id=${rule.id}`);
  }
  const content = rule.content;
  if (!content) {
    throw new Error(`missing content, id=${rule.id}`);
  }
  if (!context.url) {
    throw new Error(`missing URL in context`);
  }

  switch (content.matchType) {
    case RULE_TYPES.CONTAINS:
      return context.url.indexOf(content.value) > -1;
    case RULE_TYPES.EXACT:
      return context.url === content.value;
    case RULE_TYPES.REGEX: {
      const regex = new RegExp(content.value, 'gi');
      return !!context.url.match(regex);
    }
    default:
      throw new Error(`unknown matchType: ${content.matchType}, id=${rule.id}`);
  }
}
